<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <item-form :mode="show"/>
  </v-container>
</template>

<script>
import ItemForm from './_Form'
export default {
  name: 'AdminMasterItemNew',
  components: { ItemForm },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '品目一覧', disabled: false, to: '/admin/masters/items', exact: true },
        { text: '品目登録', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
